import { EmpreenderApps } from "../files/AppsArray";

export type AppDaCentral = (typeof EmpreenderApps)[number];

// O Empreender Plus é a porta de entrada: abre por padrão e fica fixo no topo do menu e do seletor.
export const SLUG_PLUS = "empreender-plus";
export const appPadrao = EmpreenderApps.find((app) => app.slugamigavel === SLUG_PLUS)!;

// Apps que aparecem no menu e no seletor.
const FORA_DA_LISTA = ["suporte-empreender", "compre-junto"];

const nomeNoIdioma = (app: AppDaCentral, idioma: string) => (idioma === "es" ? app.namees : app.name);

// Plus primeiro, depois ordem alfabética; `busca` filtra por nome e pelas tags.
export const appsDaCentral = (idioma: string, busca = "") => {
  const termo = busca.trim().toLowerCase();
  return EmpreenderApps.filter(
    (app) =>
      !FORA_DA_LISTA.includes(app.slugamigavel) &&
      (!termo ||
        nomeNoIdioma(app, idioma).toLowerCase().includes(termo) ||
        app.tags.some((tag) => tag.toLowerCase().includes(termo)))
  ).sort((a, b) => {
    if (a.slugamigavel === SLUG_PLUS) return -1;
    if (b.slugamigavel === SLUG_PLUS) return 1;
    return nomeNoIdioma(a, idioma).localeCompare(nomeNoIdioma(b, idioma));
  });
};
